import React from 'react';
import Svg, { Mask, Path, Rect, Circle, ClipPath, G, Defs } from 'react-native-svg';

export function AnimalFallBack({ width, height }) {
  return (
    <>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 41 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Circle cx="20.5677" cy="20.5323" r="20.0073" stroke="#E4E4E4" strokeWidth="0.482104" />
        <Path
          d="M27.8663 28.5221C27.6451 29.2405 27.2246 29.8097 26.7399 30.2197C25.675 31.1205 24.2625 31.2764 23.0305 30.6293C22.1862 30.1859 21.3803 29.3781 20.4999 29.4056C19.6196 29.3781 18.8137 30.1859 17.9694 30.6293C16.7374 31.2764 15.3249 31.1205 14.26 30.2197C13.7753 29.8097 13.3548 29.2405 13.1336 28.5221C12.9123 27.8037 12.9098 26.9265 13.2038 26.2103C13.4612 25.5833 13.9129 25.1354 14.3789 24.7947C14.845 24.454 15.3474 24.2057 15.7928 23.8197C17.4792 22.3579 17.9415 19.6506 20.4999 19.6506C23.0583 19.6506 23.5206 22.3579 25.2071 23.8197C25.6524 24.2057 26.1549 24.454 26.621 24.7947C27.087 25.1354 27.5387 25.5833 27.7961 26.2103C28.0901 26.9265 28.0876 27.8037 27.8663 28.5221Z"
          fill="#BCBCBC"
        />
        <Path
          d="M19.7243 15.3952C19.75 16.8989 18.8539 18.2125 17.4687 18.3414C16.0835 18.4704 14.811 16.9681 14.644 15.1737C14.4675 13.2776 15.8718 10.4693 17.264 10.4901C18.8449 10.5137 19.692 13.5085 19.7243 15.3952Z"
          fill="#BCBCBC"
        />
        <Path
          d="M17.5273 9.21054C17.5373 9.34378 17.5404 9.48177 17.4929 9.60663C17.4453 9.7315 17.3362 9.8413 17.203 9.85223C17.0658 9.86332 16.9371 9.76614 16.8738 9.64379C16.8105 9.52143 16.8009 9.37898 16.803 9.24114C16.8095 8.81672 16.9195 8.39522 17.1162 8.01938C17.1487 7.95736 17.2395 7.9622 17.2643 8.02766C17.4077 8.40666 17.4969 8.80633 17.5273 9.21054Z"
          fill="#BCBCBC"
        />
        <Path
          d="M14.6584 19.2856C14.9121 20.5983 14.3294 21.8863 13.1363 22.2121C11.9433 22.538 10.5981 21.4183 10.1759 19.8727C9.72989 18.2397 10.5278 15.5648 11.75 15.3689C13.1379 15.1465 14.3401 17.6385 14.6584 19.2856Z"
          fill="#BCBCBC"
        />
        <Path
          d="M11.784 14.2079C11.8133 14.323 11.8372 14.4433 11.8148 14.56C11.7924 14.6766 11.7137 14.7896 11.5987 14.8196C11.4803 14.8504 11.3527 14.7851 11.2784 14.6877C11.2042 14.5903 11.1739 14.467 11.1545 14.346C11.0949 13.9734 11.1265 13.5874 11.2409 13.2281C11.2598 13.1688 11.3401 13.1591 11.3718 13.2126C11.5557 13.5224 11.6952 13.8586 11.784 14.2079Z"
          fill="#BCBCBC"
        />
        <Path
          d="M21.2759 15.3952C21.2502 16.8989 22.1463 18.2125 23.5315 18.3414C24.9167 18.4704 26.1892 16.9681 26.3562 15.1737C26.5327 13.2776 25.1284 10.4693 23.7362 10.4901C22.1553 10.5137 21.3082 13.5085 21.2759 15.3952Z"
          fill="#BCBCBC"
        />
        <Path
          d="M23.4729 9.21054C23.4629 9.34378 23.4598 9.48177 23.5073 9.60663C23.5549 9.7315 23.664 9.8413 23.7972 9.85223C23.9344 9.86332 24.0631 9.76614 24.1264 9.64379C24.1897 9.52143 24.1993 9.37898 24.1972 9.24114C24.1907 8.81672 24.0807 8.39522 23.884 8.01938C23.8515 7.95736 23.7607 7.9622 23.736 8.02766C23.5925 8.40666 23.5033 8.80633 23.4729 9.21054Z"
          fill="#BCBCBC"
        />
        <Path
          d="M26.3417 19.2856C26.088 20.5983 26.6707 21.8863 27.8637 22.2121C29.0568 22.538 30.402 21.4183 30.8241 19.8727C31.2702 18.2397 30.4723 15.5648 29.2501 15.3689C27.8622 15.1465 26.66 17.6385 26.3417 19.2856Z"
          fill="#BCBCBC"
        />
        <Path
          d="M29.2164 14.2079C29.1871 14.323 29.1632 14.4433 29.1856 14.56C29.208 14.6766 29.2867 14.7896 29.4016 14.8196C29.5201 14.8504 29.6477 14.7851 29.722 14.6877C29.7962 14.5903 29.8265 14.467 29.8459 14.346C29.9055 13.9734 29.8739 13.5874 29.7595 13.2281C29.7406 13.1688 29.6603 13.1591 29.6286 13.2126C29.4447 13.5224 29.3052 13.8586 29.2164 14.2079Z"
          fill="#BCBCBC"
        />
      </Svg>
    </>
  );
}
